(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elite-product-details"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('elite-product-details')) return;
  const labels = ['Specifications', 'Instruction Manual', 'Prop 65'];
  const normalized = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().replace(/:\s*$/, '').toLowerCase();
  const sectionName = text => {
    switch (normalized(text)) {
      case 'description': return 'description';
      case 'specification': case 'specifications': return 'Specifications';
      case 'instruction manual': case 'instruction manuals': return 'Instruction Manual';
      case 'prop 65': case 'prop. 65': case 'proposition 65': return 'Prop 65';
      default: return null;
    }
  };
  class EliteProductDetails extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.build(), { once: true });
      } else { this.build(); }
    }
    build() {
      if (this.dataset.ready) return;
      const source = this.querySelector('.elite-product-details__source');
      if (!source) return;
      // Work on a detached copy; the original remains visible if enhancement fails.
      const copy = source.cloneNode(true);
      const markers = Array.from(copy.querySelectorAll('h1,h2,h3,h4,h5,h6'))
        .map(node => ({ node, key: sectionName(node.textContent) })).filter(item => item.key);
      const buckets = new Map(['description', ...labels].map(key => [key, document.createDocumentFragment()]));
      let previous = null;
      let key = 'description';
      for (const marker of [...markers, { node: null }]) {
        const range = document.createRange();
        if (previous) range.setStartAfter(previous); else range.setStart(copy, 0);
        if (marker.node) range.setEndBefore(marker.node); else range.setEnd(copy, copy.childNodes.length);
        buckets.get(key).append(range.cloneContents());
        range.detach();
        previous = marker.node;
        key = marker.key;
      }
      const result = document.createDocumentFragment();
      const intro = document.createElement('div');
      intro.className = 'elite-product-details__intro rte';
      intro.append(buckets.get('description'));
      if (intro.textContent.trim() || intro.querySelector('img,video,iframe,a,table')) result.append(intro);
      const paths = [
        'M4 3h16v18H4z M8 8h8 M8 12h8 M8 16h5',
        'M12 5v15 M12 5C8 2 4 3 2 4v15c3-1 6-1 10 1 4-2 7-2 10-1V4c-2-1-6-2-10 1Z',
        'M12 3 2 21h20L12 3Z M12 9v5 M12 17v1'
      ];
      labels.forEach((label, index) => {
        const details = document.createElement('details');
        details.className = 'elite-product-details__row';
        const summary = document.createElement('summary');
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('class', 'elite-product-details__icon'); icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', 'currentColor'); icon.setAttribute('stroke-width', '1.5');
        icon.setAttribute('stroke-linecap', 'round'); icon.setAttribute('stroke-linejoin', 'round');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', paths[index]); icon.append(path);
        summary.append(icon, document.createTextNode(label));
        const body = document.createElement('div');
        body.className = 'elite-product-details__body rte';
        body.append(buckets.get(label));
        details.append(summary, body); result.append(details);
      });
      source.replaceWith(result);
      this.dataset.ready = 'true';
    }
  }
  customElements.define('elite-product-details', EliteProductDetails);
})();
  } catch(e) { console.error(e); }
})();

})();
